import React 				from 'react';
import MuiThemeProvider 	from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { Router, Route } 	from 'react-router';
import createBrowserHistory from 'history/createBrowserHistory';
import DataFeedApp    		from '../data-feed/components/DataFeed.react';
import Feedback 			from '../data-feed/components/Feedback.react';
import PileCheck 			from '../data-feed/components/PileCheck.react';
injectTapEventPlugin();

const history = createBrowserHistory();

class App extends React.Component {

	constructor( props ) {

		super( props );
	}

	render() {


		let routes = [

			<Route key={1} path="/data-feed" component={DataFeedApp} />,
			<Route key={2} path="/feedback" component={Feedback} />,
			<Route key={3} path="/pile/check" component={PileCheck} />
			
		];

		return (
			<MuiThemeProvider>

				<Router history={history}>
					<div>
						{routes}
					</div>
				</Router>

			</MuiThemeProvider>
		);

	}

}

export default App;


// WEBPACK FOOTER //
// ./resources/assets/js/components/App.react.js